<div class="component-massive-cntr">
  <app-massive-payments></app-massive-payments>
</div>

<div class="component-massive-cntr">
  <app-massive-offert></app-massive-offert>
</div>

<div class="component-massive-cntr">
  <app-massive-billing></app-massive-billing>
</div>

<div class="component-massive-cntr">
  <app-massive-admin-payment></app-massive-admin-payment>
</div>
